(function() {
    'use strict';

    angular.module('process')
        .controller('ProductionCubeRealizationController', ProductionCubeRealizationController);

    ProductionCubeRealizationController.$inject = ['$q', 'productionCube', 'productToRealizationPks', 'productionCubeStatusConst', '$uibModal', '$uibModalInstance', 'notificationSrvc', 'checkModelPermissionsSrvc', 'productionCubeProductDataSrvc', 'orderProductProcessStageStatusPermissionsConst', 'orderProductProcessStageStatusDataSrvc', 'previewSrvc', 'lodashService'];

    function ProductionCubeRealizationController($q, productionCube, productToRealizationPks, productionCubeStatusConst, $uibModal, $uibModalInstance, notificationSrvc, checkModelPermissionsSrvc, productionCubeProductDataSrvc, orderProductProcessStageStatusPermissionsConst, orderProductProcessStageStatusDataSrvc, previewSrvc, lodashService) {
        var self = this;

        self.products = [];
        self.statuses = {};
        self.activateTab = activateTab;
        self.close = close;
        self.startProductionCube = startProductionCube;
        self.finishProductionCube = finishProductionCube;
        self.isStartedDisabled = isStartedDisabled;
        self.isFinishedDisabled = isFinishedDisabled;

        self.hasStatusesViewPermission = hasStatusesViewPermission;
        self.hasStatusesCreatePermission = hasStatusesCreatePermission;

        self.productionCubeRows = [{
            title: null,
            value: 'machine_action.name',
            defaultValue: null
        }];

        self.isText = isText;
        self.isDecimal = isDecimal;
        self.isList = isList;
        self.isImage = isImage;
        self.getValue = getValue;
        self.hasHelper = hasHelper;

        self.orderProductCols = [{
            title: 'Podgląd',
            value: 'product_file.client_file_thumbnail',
            type: 'image',
            onClick: previewSrvc.previewOrderFile,
            helper: {
                elementClass: 'preflight-status-icon',
                tooltip: 'product_file.preflight_status.message',
                typeClass: 'product_file.preflight_status.class'
            }
        }, {
            title: 'ID zlecenia',
            value: 'pk',
            type: 'number',
        }, {
            title: 'Nr montażu',
            value: 'montage_pk',
            type: 'number',
        }, {
            title: 'ID produktu',
            value: 'product_pk',
            type: 'number',
        }, {
            title: 'Produkt',
            value: 'product_name',
            type: 'text'
        }, {
            title: 'Nakład',
            value: 'selected_quantity',
            type: 'text'
        }, {
            title: 'Format',
            value: 'format',
            type: 'text'
        }, {
            title: 'Netto',
            value: 'net_price',
            type: 'decimal'
        }, {
            title: 'Waluta',
            value: 'currency',
            type: 'text'
        }, {
            title: 'Waga',
            value: 'weight',
            type: 'decimal'
        }, {
            title: 'Opcje',
            value: 'chosen_options',
            type: 'list',
            fields: [{
                value: 'chosen_option.group_pk',
                class: 'label label-default'
            }, {
                value: 'chosen_option.group_name',
                class: null
            }, {
                value: 'chosen_option.pk',
                class: 'label label-default'
            }, {
                value: 'chosen_option.label',
                class: null
            }, {
                value: 'user_value',
                class: 'option-value'
            }]
        }];
        self.extraActions = [{
            class: 'btn btn-xs',
            iconClass: 'fa fa-user',
            onClick: previewSrvc.getClientFile,
            isDisabled: previewSrvc.isClientFileNotAvailable,
            withLoading: true,
            title: 'Plik klienta'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-search',
            onClick: previewSrvc.getResultFile,
            isDisabled: previewSrvc.isResultFileNotAvailable,
            withLoading: true,
            title: 'Plik wyjściowy'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-user',
            onClick: previewSrvc.getClientCoverFile,
            isDisabled: previewSrvc.isClientCoverFileNotAvailable,
            displayCondition: previewSrvc.isClientCoverFileNotAvailable,
            withLoading: true,
            title: 'Plik okładki klienta'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-search',
            onClick: previewSrvc.getCoverResultFile,
            isDisabled: previewSrvc.isCoverResultFileNotAvailable,
            displayCondition: previewSrvc.isCoverResultFileNotAvailable,
            withLoading: true,
            title: 'Plik okładki wyjściowy'
        }];

        activate();

        function activate() {
            $q.all([getProductsToRealization(), getProductsToRealizationStatuses()]).then(
                function (response) {
                    activateTab(self.products[0]);
                }
            );
        }

        function activateTab(product) {
            if (!self.statuses[product.pk]) {
                getProductToRealizationStatuses(product);
            }
        }

        function getProductsToRealization() {
            return productionCubeProductDataSrvc.toRealizationList({
                production_cube_pk: productionCube.pk,
                products_pks: productToRealizationPks
            }).$promise.then(
                function(response) {
                    self.products = response;
                    return response;
                }
            );
        }

        function getProductToRealization(pk) {
            return productionCubeProductDataSrvc.toRealizationDetail({
                pk: pk,
            }).$promise.then(
                function(response) {
                    var index = self.products.findIndex(function(item) {
                        return item.pk === response.pk;
                    });
                    self.products[index] = response;
                    return response;
                }
            );
        }

        function getProductToRealizationStatuses(product) {
            return orderProductProcessStageStatusDataSrvc.list({
                order_product_pk: product.pk
            }).$promise.then(function(response) {
                self.statuses[product.pk] = response;
                return response;
            });
        }

        function getProductsToRealizationStatuses() {
            return orderProductProcessStageStatusDataSrvc.list({
                order_products_pks: productToRealizationPks
            }).$promise.then(function(response) {
                angular.forEach(productToRealizationPks, function (product_pk) {
                    self.statuses[product_pk] = lodashService.filter(response, function(status) {
                        return status.order_product === product_pk;
                    });
                });
                return response;
            });
        }

        function close() {
            $uibModalInstance.close();
        }

        function hasStatusesViewPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                orderProductProcessStageStatusPermissionsConst.view);
        }

        function hasStatusesCreatePermission() {
            return !checkModelPermissionsSrvc.isDenied(
                orderProductProcessStageStatusPermissionsConst.add);
        }

        function createStatusModal(status) {
            if (!self.hasStatusesCreatePermission()) {
                notificationSrvc.notification("error", orderProductProcessStageStatusPermissionsConst.add.errorMsg);
                return;
            }

            return $uibModal.open({
                templateUrl: 'app/process/views/production-cube-product-status/production-cube-product-status.html',
                controller: 'ProductionCubeProductStatusController',
                controllerAs: 'ctrl',
                size: 'md',
                windowClass: 'production-cube-product-status',
                resolve: {
                    products: function() {
                        if (status === productionCubeStatusConst.started) {
                            return lodashService.filter(self.products, function (product) {
                                return !isStartedDisabled(product);
                            });
                        } else {
                            return lodashService.filter(self.products, function (product) {
                                return !isFinishedDisabled(product);
                            });
                        }
                    },
                    status: function() {
                        return status;
                    }
                }
            });
        }

        function startProductionCube(product) {
            return createStatusModal(productionCubeStatusConst.started)
                .result.then(function(isCreated) {
                    if (isCreated) {
                        getProductsToRealizationStatuses();
                    }
                });
        }

        function finishProductionCube(product) {
            return createStatusModal(productionCubeStatusConst.finished)
                .result.then(function(isCreated) {
                    if (isCreated) {
                        productionCube.isStatusFinished = true;
                        getProductsToRealization();
                        getProductsToRealizationStatuses();
                        close();
                    }
                });
        }

        function isStartedDisabled(product) {
            if (!product.process_stage || !self.statuses[product.pk]) {
                return true;
            }

            if (!self.statuses[product.pk].length) {
                return false;
            }

            var lastStatus = self.statuses[product.pk][self.statuses[product.pk].length - 1];
            return lastStatus.process_stage === product.process_stage.pk;
        }

        function isFinishedDisabled(product) {
            if (!product.process_stage || !self.statuses[product.pk]) {
                return true;
            }

            if (!self.statuses[product.pk].length) {
                return true;
            }

            var lastStatus = self.statuses[product.pk][self.statuses[product.pk].length - 1];
            return lastStatus.process_stage !== product.process_stage.pk;
        }

        function isText(column) {
            return column.type === "text" ||
                column.type === "number" ||
                column.type === undefined;
        }

        function isDecimal(column) {
            return column.type === "decimal";
        }

        function isList(column) {
            return column.type === "list";
        }

        function isImage(column) {
            return column.type === "image";
        }

        function getValue(obj, key) {
            var value =  key.split(".").reduce(function(result, key) {
                return result && result[key] ? result[key] : '';
            }, obj);
            return value || null;
        }

        function hasHelper(column) {
            return column.hasOwnProperty('helper');
        }
    }
})();
